module.exports = __webpack_public_path__ + "img/image-13.b0ba040d.webp";